import React from "react";

import {
  PrimaryBlockType,
  primaryBlock,
  PrimaryBlockConfig,
  SecondaryBlockSize,
  TertiaryBlockSize,
  BlockTheme,
  renderSecondaryBlock,
  renderTertiaryBlock,
  getDefaultProps,
  BlockType,
  Shared,
} from "@kameleon-core/lib";
import { Box } from "theme-ui";
import { Variants } from "@kameleon-util/global-theme";
import { LayoutProps } from "../types/prop-types";
import defaults from "../defaults.json";

export type SliderItemType = {
  /** Place prop documentation here */
  image: Shared.Props.MediaProp;
  tagline: string;
  title: string;
  description: string;
  _parentBgColor?: string;
} & PrimaryBlockType<LayoutProps>;

/** SliderItem PrimaryCollection */
export const blockConfig: PrimaryBlockConfig = {
  secondaryBlockSize: SecondaryBlockSize.Small,
  tertiaryBlockSize: TertiaryBlockSize.Default,
  blockTheme: BlockTheme.light,
  blockType: BlockType.PrimaryCollection,
};

export const SliderItem = primaryBlock<SliderItemType>(
  { isInnerBlock: true, ...blockConfig },
  ({
    SecondaryBlock,
    TertiaryBlock,
    tagline,
    title,
    description,
    layoutProps,
    image,
    _parentBgColor,
  }: SliderItemType) => (
    <Box
      className="primary-collection-slider-three-col-small-media-v1"
      sx={{ backgroundColor: _parentBgColor ?? "transparent" }}
    >
      <Box variant={layoutProps.itemBackground ? "cards.primary" : "box"}>
        <Variants.CardHorizontal hasPadding={false} className="blog65_item">
          <Variants.Link href="#" className="blog65_image-link w-inline-block">
            <Box className="blog65_image-wrapper">
              <Variants.ImageCardHorizontal
                src={image.url}
                loading="lazy"
                alt={image.alt}
                className="blog65_image"
              />
            </Box>
          </Variants.Link>
          <Variants.CardHorizontal hasPadding={layoutProps.itemBackground}>
            <Variants.LinkText
              href="#"
              className="blog65_category-link w-inline-block"
            >
              {tagline && <Box>{tagline}</Box>}
            </Variants.LinkText>
            <Variants.LinkText
              href="#"
              className="blog65_title-link w-inline-block"
            >
              {title && (
                <Variants.Heading as="h3" variant="h5">
                  {title}
                </Variants.Heading>
              )}
            </Variants.LinkText>
            <Box>{description}</Box>
            {renderSecondaryBlock(SecondaryBlock)}
            {renderTertiaryBlock(TertiaryBlock)}
          </Variants.CardHorizontal>
        </Variants.CardHorizontal>
      </Box>
    </Box>
  )
);

const itemDefaults = {
  layoutProps: defaults.layoutProps,
  contentProps: defaults.contentProps.PrimaryBlocks[0] ?? {},
};
SliderItem.defaultProps = getDefaultProps<SliderItemType>(itemDefaults);
